import axios from "axios";

const apiURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// ==========================================
// LEATHER API (KHO DA)
// ==========================================

// Lấy danh sách da (public - chỉ da không bị ẩn)
export const getAllLeathers = async () => {
    try {
        let res = await axios.get(`${apiURL}/api/leather/all-leathers`);
        return res.data;
    } catch (error) {
        console.log(error);
        return { error: "Network Error" };
    }
};

// Lấy tất cả da cho admin (bao gồm cả da đã ẩn/sold)
export const getAllLeathersAdmin = async () => {
    try {
        let res = await axios.get(`${apiURL}/api/leather/all-leathers-admin`);
        return res.data;
    } catch (error) {
        console.log(error);
        return { error: "Network Error" };
    }
};

// Thêm da mới (Có kèm vùng cấm restrictedAreas, Tên, Giá)
export const createLeather = async (formData) => {
    try {
        let res = await axios.post(`${apiURL}/api/leather/add-leather`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { error: "Network Error" };
    }
};

// Xóa miếng da
export const deleteLeatherItem = async (id) => {
    try {
        let res = await axios.delete(`${apiURL}/api/leather/delete-leather/${id}`);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { error: "Network Error" };
    }
};

// Ẩn/Hiện miếng da thủ công
export const toggleHideLeatherAPI = async (id, isHidden) => {
    try {
        let res = await axios.patch(`${apiURL}/api/leather/${id}/hide`, { isHidden });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { error: "Network Error" };
    }
};

// Cập nhật vùng đã cắt (Used Areas)
export const updateUsedAreas = async (id, data) => {
    try {
        const res = await fetch(`${apiURL}/api/leather/update-used/${id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });
        return await res.json();
    } catch (error) {
        console.error("Lỗi fetch:", error);
    }
};

// // MỚI: Upload ảnh chụp màn hình (Base64) lên AWS S3
// export const uploadMockupImage = async (base64Image) => {
//     try {
//         let res = await axios.post(`${apiURL}/api/leather/upload-mockup`, { image: base64Image });
//         return res.data;
//     } catch (error) {
//         return error.response ? error.response.data : { error: "Network Error" };
//     }
// };ß

// ==========================================
// ORDER API (ĐƠN HÀNG)
// ==========================================

// Upload mockup + overview images lên S3 trước khi submit order
export const uploadOrderImages = async (mockupBase64, overviewBase64) => {
    try {
        let res = await axios.post(`${apiURL}/api/order/upload-images`, {
            mockupImageUrl: mockupBase64,
            overviewImageUrl: overviewBase64
        });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { error: "Network Error" };
    }
};

// Khách hàng submit thiết kế mới (Từ trang Home)
export const submitOrder = async (orderData) => {
    try {
        let res = await axios.post(`${apiURL}/api/order/submit-order`, orderData);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { error: "Network Error" };
    }
};

// Admin lấy danh sách tất cả các đơn khách đã thiết kế (Hiển thị Dashboard)
export const getAllOrders = async () => {
    try {
        let res = await axios.get(`${apiURL}/api/order/all-orders`);
        return res.data;
    } catch (error) {
        console.log(error);
        return { error: "Network Error" };
    }
};
export const updateLeatherStatusAction = async (id, action) => {
    try {
        const res = await fetch(`${apiURL}/api/leather/action/${id}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ action }),
        });
        return await res.json();
    } catch (error) {
        console.error("Lỗi fetch action:", error);
    }
};
// Cập nhật thông tin miếng da (Edit)
export const updateLeather = async (id, formData) => {
    try {
        let res = await axios.put(`${apiURL}/api/leather/update-leather/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { error: "Network Error" };
    }
};

export const updateLeatherOrderAPI = async (orderedItems) => {
    try {
        let res = await axios.post(`${apiURL}/api/leather/update-order`, { orderedItems });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { error: "Network Error" };
    }
};
export const getAllLocales = async () => {
    try {
        let res = await axios.get(`${apiURL}/api/locales/all`);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

export const createLocale = async (formData) => {
    try {
        // Gửi formData (chứa cả text và file)
        let res = await axios.post(`${apiURL}/api/locales/create`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

export const deleteLocale = async (id) => {
    try {
        let res = await axios.delete(`${apiURL}/api/locales/delete/${id}`);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

export const updateLocale = async (id, formData) => {
    try {
        let res = await axios.put(`${apiURL}/api/locales/update/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

// ==========================================
// STRAP OPTIONS API (TÙY CHỌN DÂY)
// ==========================================

export const getStrapOptions = async () => {
    try {
        let res = await axios.get(`${apiURL}/api/strap-options`);
        if (res.data && res.data.options) {
            res.data.options.forEach(opt => {
                if (opt.choices) {
                    const seen = new Set();
                    opt.choices.forEach((c, idx) => {
                        let val = c.value || `choice_${idx}`;
                        while (seen.has(val)) { val = `${val}_${idx}`; }
                        seen.add(val);
                        c.value = val;
                    });
                }
            });
        }
        return res.data;
    } catch (error) {
        return { success: false, options: [] };
    }
};

export const getAllStrapOptionsAdmin = async () => {
    try {
        let res = await axios.get(`${apiURL}/api/strap-options/all-admin`);
        if (res.data && res.data.options) {
            res.data.options.forEach(opt => {
                if (opt.choices) {
                    const seen = new Set();
                    opt.choices.forEach((c, idx) => {
                        let val = c.value || `choice_${idx}`;
                        while (seen.has(val)) { val = `${val}_${idx}`; }
                        seen.add(val);
                        c.value = val;
                    });
                }
            });
        }
        return res.data;
    } catch (error) {
        return { success: false, options: [] };
    }
};

export const createStrapOption = async (data) => {
    try {
        let res = await axios.post(`${apiURL}/api/strap-options/create`, data);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

export const updateStrapOption = async (id, data) => {
    try {
        let res = await axios.put(`${apiURL}/api/strap-options/update/${id}`, data);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

export const deleteStrapOption = async (id) => {
    try {
        let res = await axios.delete(`${apiURL}/api/strap-options/delete/${id}`);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

export const uploadChoiceImage = async (formData) => {
    try {
        let res = await axios.post(`${apiURL}/api/strap-options/upload-choice-image`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

// ==========================================
// STRAP OPTION CATEGORY API
// ==========================================

export const getStrapOptionCategories = async () => {
    try {
        let res = await axios.get(`${apiURL}/api/strap-option-category`);
        return res.data;
    } catch (error) {
        return { success: false, categories: [] };
    }
};

export const createStrapOptionCategory = async (data) => {
    try {
        let res = await axios.post(`${apiURL}/api/strap-option-category`, data);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};

export const deleteStrapOptionCategory = async (id) => {
    try {
        let res = await axios.delete(`${apiURL}/api/strap-option-category/${id}`);
        return res.data;
    } catch (error) {
        return error.response ? error.response.data : { success: false, error: "Network Error" };
    }
};